import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useErrorHandler } from 'react-error-boundary';

import { useDidMount } from '../../customHooks';
import { saveBusiness, saveLgCd } from '../../redux_toolkit/reserveSlice';
// import { saveRsvMode, saveTopicPath, saveMaxAttendees } from '../../redux_toolkit/rsvConfigSlice';
// import rsvScnMastaApi from '../../api/masta/rsvScnMasta';
// import rsvSettingMastaApi from '../../api/masta/rsvSettingMasta';
import servNameApi from '../../api/masta/servNameMasta';
import serviceIcon from '../../images/ico_service.svg';
import TopicPath from '../../components/TopicPath';
import rsvDocMastaApi from '../../api/masta/rsvDocMasta';

import { saveConfig, saveDispBusinessSelect } from '../../redux_toolkit/rsvConfigSlice';
import rsvScnMastaApi from '../../api/masta/rsvScnMasta';
import rsvSettingMastaApi from '../../api/masta/rsvSettingMasta';
import topApi from '../../api/reserve/top';

import { HOME_ONLY, PURPOSE_RSV, CANCEL_ANNOUNCE } from '../../constants';

const Top = function () {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleError = useErrorHandler();

  const [serviceName, setServiceName] = useState('');
  const [lgName, setLgName] = useState('');

  const [termsUrl, setTermsUrl] = useState(null);
  const [termsLabel, setTermsLabel] = useState('');
  const [policyUrl, setPolicyUrl] = useState(null);
  const [policyLabel, setPolicyLabel] = useState('');
  const [checkboxLabel, setCheckboxLabel] = useState('');
  const [agreed, setAgreed] = useState(false);

  const rsvMode = useSelector((state) => state.rsvConfig.rsvMode);

  const isLoggedIn = useSelector((state) => state.login.accessToken);

  useDidMount(() => {
    // 初期処理
    const init = async () => {
      const servNameData = await servNameApi
        .getServName(params.lgCd, 'reserve-top')
        .catch((err) => {
          window.alert('サービス名の取得に失敗しました。');
          handleError(err);
        });
      const { servName = '', lgName = '', dispBusinessSelect = true } = servNameData;

      if (servName === '' && lgName === '') {
        navigate('/unregistered');
        return;
      }

      const itemid = searchParams.get('id');

      if (!dispBusinessSelect && !itemid && !isLoggedIn) {
        navigate('/unregistered');
        return;
      }

      dispatch(saveDispBusinessSelect({ dispBusinessSelect }));

      try {
        const rsvDoc = await rsvDocMastaApi.getRsvDoc(params.lgCd);

        const {
          terms_of_service: terms = '',
          privacy_policy: policy = '',
          checkbox_label: checkboxLabel = '',
        } = rsvDoc;
        const { url: termsUrl = '', label: termsLabel = '' } = terms;
        const { url: policyUrl = '', label: policyLabel = '' } = policy;

        setServiceName(servName);
        setLgName(lgName);

        setTermsUrl(termsUrl);
        setTermsLabel(termsLabel);
        setPolicyUrl(policyUrl);
        setPolicyLabel(policyLabel);
        setCheckboxLabel(checkboxLabel);

        if (itemid) {
          const response = await topApi.getRecItem(itemid, params.lgCd).catch((err) => {
            if (err.response?.status === 400) {
              return null; // 400エラーは正常にハンドリング
            }
            throw err; // その他のエラーは外側のcatchへ
          });

          if (!response?.recItem) {
            window.alert('申請項目を取得できませんでした。');
            navigate(`/${params.lgCd}`);
            return;
          }

          const { business, recItem, locationSetting = {} } = response;
          const { rsvSetId = null, formSetId = null } = recItem;

          const rsvSetting = await rsvSettingMastaApi.getRsvSetting(rsvSetId);
          const {
            rsv_mode: mode = null,
            max_attendees: maxAttendees = 0,
            rsv_place: rsvPlaceIds = [],
            rsv_tell_place: rsvTelPlaceIds = [],
            tell_start: telStart = 3,
          } = rsvSetting;
          const rsvScnList = await rsvScnMastaApi.getRsvScn(mode, PURPOSE_RSV);

          const topicPathList = rsvScnList
            .filter((obj) => obj.rsv_url !== 'business')
            .map((obj) => ({
              url: obj.rsv_url,
              scnName: obj.scn_name,
            }));

          dispatch(
            saveConfig({
              rsvMode: mode,
              topicPath: topicPathList,
              maxAttendees,
              rsvPlaceIds,
              rsvTelPlaceIds,
              telStart,
              skipItemSelect: true,
              dispBusinessSelect,
              locationSetting,
            })
          );

          dispatch(saveBusiness({ business, recItem: [recItem], rsvSetId, formSetId }));
        }
      } catch (err) {
        window.alert('予約受付設定の取得に失敗しました。');
        handleError(err);
      }
    };

    sessionStorage.setItem('lgCd', params.lgCd);
    dispatch(saveLgCd({ lgCd: params.lgCd }));
    init();
  });

  const onClickRsvStart = () => {
    // 規約文書のurlが取得できていない場合はreturn
    if (termsUrl === null || policyUrl === null) return;
    // 規約文書のurlが取得できて同意されていない場合はreturn
    if ((termsUrl || policyUrl) && !agreed) return;

    const itemid = searchParams.get('id');
    if (itemid) {
      if (rsvMode !== null && rsvMode !== HOME_ONLY) {
        navigate(`/place?id=${itemid}`);
      } else {
        navigate(`/date?id=${itemid}`);
      }
    } else {
      navigate('/business');
    }
  };

  document.title = `${lgName} ${serviceName}`;

  return (
    <>
      <TopicPath />
      <main>
        <article />
        <div id="contents">
          <div className="inner450">
            <h2 className="point">
              <span className="logo">
                <img src={serviceIcon} alt="" width="60" height="60" />
              </span>
              <span className="name">{lgName}</span> {serviceName}
            </h2>
            {(termsUrl || policyUrl) && (
              <div className="txtCenter">
                {termsUrl && (
                  <p className="mb10">
                    <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                      {/* 利用規約 */}
                      {termsLabel}
                    </a>
                  </p>
                )}
                {policyUrl && (
                  <a href={policyUrl} target="_blank" rel="noopener noreferrer">
                    {/* プライバシーポリシー */}
                    {policyLabel}
                  </a>
                )}
                <p className="mb30 mt20">
                  <input
                    id="agreedCheck"
                    type="checkbox"
                    checked={agreed}
                    onChange={() => setAgreed(!agreed)}
                  />
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="agreedCheck">
                    {/* 内容を確認しました。 */}
                    {checkboxLabel}
                  </label>
                </p>
              </div>
            )}
            <p className="txtCenter">
              <strong>下記のボタンから予約を開始してください。</strong>
            </p>
            <p>
              <a
                // href="javascript:void(0);"
                role="button"
                className="btn btStart"
                disabled={(termsUrl || policyUrl) && !agreed}
                onClick={onClickRsvStart}
                tabIndex={0}
              >
                予約を開始する
              </a>
            </p>
          </div>
          <div className='cancelAnnounce'>{CANCEL_ANNOUNCE}</div>
        </div>
      </main>
    </>
  );
};

export default Top;
